function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 3C9.10875 3 6.75 5.35875 6.75 8.25C6.75 10.0342 7.6575 11.613 9.02325 12.5625C5.9445 13.764 3.75 16.764 3.75 20.25H5.25C5.25 16.9515 7.64325 14.1945 10.7812 13.617L11.25 15H12.75L13.2188 13.617C16.3568 14.1945 18.75 16.9515 18.75 20.25H20.25C20.25 16.764 18.0555 13.764 14.9767 12.5625C16.3418 11.613 17.25 10.0342 17.25 8.25C17.25 5.35875 14.8912 3 12 3ZM12 4.5C14.0798 4.5 15.75 6.17025 15.75 8.25C15.75 10.3298 14.0798 12 12 12C9.92025 12 8.25 10.3298 8.25 8.25C8.25 6.17025 9.92025 4.5 12 4.5ZM11.25 15.75L10.5 20.25H13.5L12.75 15.75H11.25Z",
  fill: "#E6E6E6"
});

function SvgCompetitors(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompetitors);
export default __webpack_public_path__ + "static/media/competitors.35e18f2d.svg";
export { ForwardRef as ReactComponent };